export function getBundleWithMostSavings(bundles) {
    var mostSavings = Math.max.apply(Math, bundles.map(function (bundle) {
        return bundle.averageMonthlySavingsCents
            ? bundle.averageMonthlySavingsCents
            : 0;
    }));
    return bundles.find(function (bundle) {
        return bundle.averageMonthlySavingsCents == mostSavings;
    });
}
